import React, { Component } from 'react';
import { Grid } from 'react-bootstrap';
import PageTitle from '../../common/page-title';
import Carousel from './carousel';

class AdminHomePageMenu extends Component {
  constructor(props) {
    super(props);

    this.type = this.props.match.params.type;
  }

  render() {
    const { type } = this;

    return (
      <Grid bsClass="container" fluid className="homepagemenu">
        <PageTitle>
          Homepage Carousel
        </PageTitle>
        <Carousel type={type}/>
      </Grid>
    );
  }
}

export default AdminHomePageMenu;



// WEBPACK FOOTER //
// ./src/components/admin/homepagemenu/index.jsx